import { render, staticRenderFns } from "./LeftBuild.vue?vue&type=template&id=139771fe&scoped=true"
import script from "./LeftBuild.vue?vue&type=script&lang=js"
export * from "./LeftBuild.vue?vue&type=script&lang=js"
import style0 from "./LeftBuild.vue?vue&type=style&index=0&id=139771fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139771fe",
  null
  
)

export default component.exports